import { render, staticRenderFns } from "./TableAlarms.vue?vue&type=template&id=27fc9b1c&scoped=true&"
import script from "./TableAlarms.vue?vue&type=script&lang=js&"
export * from "./TableAlarms.vue?vue&type=script&lang=js&"
import style0 from "./TableAlarms.vue?vue&type=style&index=0&id=27fc9b1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fc9b1c",
  null
  
)

export default component.exports